





































































import { Vue, Component, Ref, Watch } from 'vue-property-decorator'
import { debounce, event } from 'quasar'
import Fullscreen from 'components/modals/Fullscreen.vue'
import PullAndScroll from 'components/PullAndScroll.vue'
import SearchResults from 'components/presenter/search/SearchResults.vue'
import TrashSearchResults from 'components/presenter/search/TrashSearchResults.vue'
import api from 'src/assets/api/gql'
import Search from 'src/graphql/search/Search.gql'
import TrashSearch from 'src/graphql/search/TrashSearch.gql'

@Component({
  components: {
    Fullscreen,
    PullAndScroll,
    SearchResults,
    TrashSearchResults
  }
})
export default class PresenterSearchDialog extends Vue {
  trash = false
  query = ''
  loading = false
  found = Object.freeze([])
  cursor: string | null = null

  @Ref()
  readonly viewscroll!: Element

  @Ref()
  readonly viewport!: PullAndScroll

  @Ref()
  readonly searchDialog!: Fullscreen

  created () {
    this.searchExisting = debounce(this.searchExisting, 1000)
    this.searchTrash = debounce(this.searchTrash, 1000)
  }

  mounted () {
    document.body.addEventListener('keyup', e => this.keyboardShow(e))
  }

  beforeDestroy () {
    document.body.removeEventListener('keyup', e => this.keyboardShow(e))
  }

  keyboardShow (e: KeyboardEvent) {
    if (e.key === '/') {
      this.searchDialog?.show()
    }
  }

  show () {
    this.searchDialog.show()
  }

  hide () {
    this.searchDialog.hide()
  }

  clear () {
    this.query = ''
    this.trash = false
    this.empty()
  }

  empty () {
    this.query = ''
    this.found = Object.freeze([])
    this.cursor = null
    this.loading = false
  }

  @Watch('query')
  searchByQuery () {
    this.viewport && this.viewport.refresh(() => {})
  }

  @Watch('trash')
  searchByTrash () {
    this.viewport && this.viewport.refresh(() => {})
  }

  async refresh (done: () => void) {
    this.found = []
    this.cursor = null
    done()
  }

  async load (index: number, done: (stop?: boolean) => void) {
    this.loading = true
    if (this.query.length > 1 || (this.trash && !this.query)) {
      if (this.trash) {
        await this.searchTrash(this.query, this.cursor, done)
      } else {
        await this.searchExisting(this.query, this.cursor, done)
      }
    } else {
      this.loading = false
      done(true)
    }
  }

  async searchExisting (query: string, cursor: string | null, done: (stop?: boolean) => void) {
    const { data: { search } } = await api.query({
      query: Search,
      variables: {
        text: query,
        after: cursor
      }
    })
    if (query === this.query && !this.trash) {
      this.found = Object.freeze([...this.found, ...search.nodes]) as never[]
      this.cursor = search.pageInfo.hasNextPage ? search.pageInfo.endCursor : null
      this.loading = false
      done(!this.cursor)
    }
  }

  async searchTrash (query: string, cursor: string | null, done: (stop?: boolean) => void) {
    const { data: { trashSearch } } = await api.query({
      query: TrashSearch,
      variables: {
        text: query,
        after: cursor
      }
    })
    if (query === this.query && this.trash) {
      this.found = Object.freeze([...this.found, ...trashSearch.nodes]) as never[]
      this.cursor = trashSearch.pageInfo.hasNextPage ? trashSearch.pageInfo.endCursor : null
      this.loading = false
      done(!this.cursor)
    }
  }

  remove (item: never) {
    const index = this.found.indexOf(item)
    this.found = Object.freeze([...this.found.slice(0, index), ...this.found.slice(index+1)]) as never[]
  }
}
